<template>
  <div
    v-if="show"
    @click.stop="$emit('reset')"
    class="absolute -right-1.5 top-1/5 -translate-y-1/2 w-5 h-5 rounded-full bg-orange-500 hover:bg-orange-600 flex items-center justify-center cursor-pointer z-10 shrink-0"
    style="aspect-ratio: 1/1;"
    title="Reset to inherited value"
  >
    <RotateCcw class="w-3 h-3 text-white" style="stroke-width: 3px;" />
  </div>
</template>

<script setup lang="ts">
import { RotateCcw } from 'lucide-vue-next'

interface Props {
  show?: boolean
}

defineProps<Props>()

defineEmits<{
  reset: []
}>()
</script>
